import { render, staticRenderFns } from "./usm-performance-and-portfolio-tables.vue?vue&type=template&id=67cac66a&"
var script = {}
import style0 from "./usm-performance-and-portfolio-tables.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports